<template>
    <v-data-table
        v-model="selected"
        :headers="headers"
        :items="usuarios"
        :search="search" 
        item-key="id"
        class="elevation-1"
    >
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title style="color:#1C2546;margin-top:40px">Administración de Usuarios/Empleados</v-toolbar-title>
                <v-divider class="mx-4" inset vertical style="margin-top:30px"></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <div class="text-right" style="margin-top:35px">
                <v-btn class="ma-2" tile color="primary" dark @click="add_new = true">
                    <v-icon left>mdi-account-plus</v-icon> Añadir nuevo
                </v-btn>
            </div>
            <v-dialog v-model="confirmacion_delete"  max-width="850">
                <v-card>
                    <v-card-title><span class="headline">Eliminar Usuario</span></v-card-title>
                    <v-card-text>
                        ¿Estas seguro de eliminar este usuario?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="confirmacion_delete = false">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="delete_user">Confirmar</v-btn>
                    </v-card-actions>
                </v-card> 
            </v-dialog>
            <v-dialog v-model="add_new"  max-width="850" >  
                <v-card>
                    <v-card-title>
                    <span class="headline">Añadir nuevo empleado</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-alert dense text type="error" dismissible close-icon="mdi-delete" v-if="alerta_new_puesto" v-model="alerta_new_puesto">El puesto ya esta asignado a otro usuario, por favor seleccione otro o cree uno nuevo.</v-alert>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="new_empleado.nombre" label="Nombre"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="12" md="6">
                                    <v-text-field v-model="new_empleado.sun_code" label="Código SUN"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-select v-model="new_empleado.id_centro_costos" :items="centros_costos" item-value="id_CentrosCostos" item-text="id_CentrosCostos" label="Centro de Costos" ></v-select>
                                </v-col>
                                <v-col cols="6" sm="12" md="6">
                                    <v-select v-model="new_empleado.id_departamento" :items="departamentos" item-value="id" item-text="nombre" label="Departamento" @change="getPuestos(new_empleado.id_departamento)" ></v-select>
                                </v-col>
                                <v-col cols="6" sm="12" md="6">
                                    <v-select v-model="new_empleado.id_puesto" :items="puestos" item-value="id" item-text="nombre" label="Puestos" @change="validar_puesto_seleccionado"></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="new_empleado.username" label="Nombre de Usuario"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field label="Contraseña" :type="(isVisible ? 'text' : 'password')" v-model="new_empleado.password">
                                        <div slot="append">
                                            <v-icon class="pointer" @click="isVisible=!isVisible">{{isVisible ? 'mdi-eye-off' : 'mdi-eye'}}</v-icon>
                                        </div>
                                    </v-text-field>   
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close_new">Cancelar</v-btn>
                            <v-btn color="blue darken-1" text @click="save_new">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="edit"  max-width="850" >  
                <v-card>
                    <v-card-title>
                    <span class="headline">Editar empleado</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-alert dense text type="error" dismissible close-icon="mdi-delete" v-if="alerta_edit_puesto" v-model="alerta_edit_puesto">El puesto ya esta asignado a otro usuario, por favor seleccione otro o cree uno nuevo.</v-alert>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="editing_empleado.nombre" label="Nombre"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-text-field v-model="editing_empleado.sun_code" label="Código SUN"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-select v-model="editing_empleado.id_centro_costos" :items="centros_costos" item-value="id_CentrosCostos" item-text="id_CentrosCostos" label="Centro de Costos" ></v-select>
                                </v-col>
                                <v-col cols="6" sm="12" md="6">
                                    <v-select v-model="editing_empleado.id_departamento" :items="departamentos" item-value="id" item-text="nombre" label="Departamento" @change="getPuestos(editing_empleado.id_departamento)"></v-select>
                                </v-col>
                                <v-col cols="6" sm="12" md="6">
                                    <v-select v-model="editing_empleado.id_puesto" :items="puestos" item-value="id" item-text="nombre" label="Puestos"  @change="validar_puesto_seleccionado"></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="editing_empleado.username" label="Nombre de Usuario"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field label="Contraseña" :type="(isVisible ? 'text' : 'password')" v-model="editing_empleado.password" hint="Dejar vacio para no cambiar contraseña" persistent-hint >
                                        <div slot="append">
                                            <v-icon class="pointer" @click="isVisible=!isVisible">{{isVisible ? 'mdi-eye-off' : 'mdi-eye'}}</v-icon>
                                        </div>
                                    </v-text-field>   
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-switch v-model="editing_empleado.status" color="green">
                                        <template v-slot:label>
                                            
                                            <div v-if="editing_empleado.status">Acceso Permitido</div>
                                            <div v-else>Acceso Denegado</div>
                                        </template>
                                    </v-switch>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close_edit">Cancelar</v-btn>
                            <v-btn color="blue darken-1" text @click="save_edit">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_historial" max-width="1000px">
                <v-card>
                    <v-card-title><span class="headline">Historial de movimientos</span></v-card-title>
                    <v-card-text>
                        <v-data-table :headers="headers_historial" :items="historial" class="elevation-1"></v-data-table>
                    </v-card-text>
                </v-card>     
            </v-dialog>
            <v-row justify="center">
                <v-col cols="10" sm="10" md="10">
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Buscar">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row class="justify-content-center col-lg-12">      
                <v-alert type="success" :value='alertSucess' close-text="Cerrar">
                    {{ message }}
                </v-alert> 
                <v-alert type="error" :value='alertError' close-text="Cerrar">
                    {{ message }}
                </v-alert> 
            </v-row>
        </template>
        <template v-slot:item.actions="{ item }">
            <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
            >
                mdi-pencil
            </v-icon>
            <v-icon
                small
                class="mr-2"
                @click="deleteItem(item)"
            >
                mdi-delete
            </v-icon>
            <v-icon
                small
                @click="getHistorialMovimientos(item)"
            >
                mdi-eye
            </v-icon>
        </template>
    </v-data-table>
</template>

<script>
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import router from '../router/index.js';

export default {
    data(){
        return {
            headers: [
                { text: "Nombre", value: "nombre", sortable: true },
                //{ text: "OPS IF", value: "ops_if", sortable: false },
                { text: "Código SUN", value: "sun_code", sortable: false },
                { text: "Centro de Costos", value: "id_centro_costos", sortable: true },
                { text: "Departamento", value: "departamento", sortable: true },
                { text: "Puesto", value: "puesto", sortable: true },
                { text: "Usuario", value: "username", sortable: true },
                { text: "Fecha Creación", value: "fecha_creacion", sortable: true },
                { text: "Fecha Edición", value: "fecha_modificacion", sortable: true },
                { text: "Acciones", value: "actions", sortable: false }
            ],
            usuarios: [],
            selected: [],
            search: '',
            item_to_delete: '',
            add_new: false,
            confirmacion_delete: false,
            alerta_new_puesto: false,
            alerta_edit_puesto: false,
            new_empleado: {
                nombre: '',
                ops_if: 1,
                sun_code: '',
                id_centro_costos: '',
                id_puesto: '',
                id_departamento: '',
                username: '',
                password: ''
            },
            ops_if: [
                '1',
                '0'
            ],
            centros_costos: [],
            departamentos: [],
            puestos: [],
            isVisible: false,
            message: '',
            alertSucess: false,
            alertError: false,
            editing_empleado: {
                status: "true"
            },
            edit: false,
            headers_historial: [
                { text: "fecha", value: "fecha", sortable: true },
                { text: "Movimiento", value: "tipo_movimiento", sortable: true},
                { text: "Detalle", value: "detalle", sortable: false },
            ],
            historial: [],
            dialog_historial: false
        }
    },
    mounted() {
        // Config for axios
        axios.defaults.headers.common['access-token'] = this.$store.state.token;
        axios.interceptors.response.use(function (response){
            if (response.data.message == 'Token inválida') {
                router.push({name: 'login', params: {errorToken: 'true'}});
            }else{
                return response;
            }
        },function(error){
            if(error){
                //console.log(error);
            }  
        });
        // End config for axios
        this.getUsuarios();
        this.getCentros();
        this.getDepartamentos();
    },
    methods: {
        getUsuarios() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/usuarios").then(res => {
                //console.log(res.data);
                this.usuarios = res.data;
            });
        },
        getCentros() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/centroscostos").then(res => {
                this.centros_costos = res.data;
            });
        },
        getDepartamentos() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/departamentos").then(res => {
                this.departamentos = res.data;
            });
        },
        getPuestos(id) {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/puestos/"+id).then(res => {
                this.puestos = res.data;
            });
        },
        close_new(){
            this.new_empleado.nombre = '';
            this.new_empleado.ops_if = '';
            this.new_empleado.sun_code = '';
            this.new_empleado.id_centro_costos = '';
            this.new_empleado.id_puesto = '';
            this.new_empleado.id_departamento = '';
            this.new_empleado.i_user = '';
            this.new_empleado.username = '';
            this.new_empleado.password = '';
            this.add_new = false;
        },
        save_new(){
            this.new_empleado.ops_if = 1;
            this.new_empleado.id =  parseInt(this.usuarios[this.usuarios.length-1].id) + 1;
            this.new_empleado.id_user = uuidv4();
            axios.post("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/usuarios/",this.new_empleado).then(res => {
                //console.log(res);
                this.message = res.data.message;
                this.alertError = false;
                this.alertSucess = true;
                this.new_empleado.nombre = '';
                this.new_empleado.ops_if = '';
                this.new_empleado.sun_code = '';
                this.new_empleado.id_centro_costos = '';
                this.new_empleado.id_puesto = '';
                this.new_empleado.id_departamento = '';
                this.new_empleado.i_user = '';
                this.new_empleado.username = '';
                this.new_empleado.password = '';
                this.add_new = false;
                this.getUsuarios();
                this.puestos = [];
            });
        },
        deleteItem(item){
            this.item_to_delete = item;
            this.confirmacion_delete = true;
        },
        delete_user(){
            axios.delete("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/usuarios/"+this.item_to_delete.id).then(res => {
                this.message = res.data.message;
                this.alertError = false;
                this.alertSucess = true;
                this.getUsuarios();
                this.confirmacion_delete = false;
            });
        },
        editItem(item){
            this.editing_empleado = item;
            //console.log(this.editing_empleado);
            this.getPuestos(item.id_departamento);
            this.edit = true;
        },
        close_edit(){
            this.editing_empleado = {};
            this.edit = false;
        },
        save_edit(){
            axios.put("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/usuarios/",this.editing_empleado).then(res => {
                //console.log(res);
                this.message = res.data.message;
                this.alertError = false;
                this.alertSucess = true;

                this.editing_empleado = {};
                this.edit = false;
                this.getUsuarios();
                this.puestos = [];
            });
        },
        getHistorialMovimientos(item){
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/usuarios/historial/"+item.id).then(res => {
                //console.log(res.data);
                this.historial = res.data;
                this.dialog_historial = true;
            });
        },
        validar_puesto_seleccionado(){
            var id_puesto;
            if (this.add_new === true) {
                id_puesto = this.new_empleado.id_puesto;
            } else {
                id_puesto = this.editing_empleado.id_puesto;
            }
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/puestos/validar_puesto/"+id_puesto).then(res => {
                if (res.data.status === true) {
                    if (this.add_new === true) {
                        this.alerta_new_puesto = true;
                        this.new_empleado.id_puesto = null;
                    } else {
                        this.alerta_edit_puesto = true;
                        this.editing_empleado.id_puesto = null;
                    }
                }else{
                    if (this.alerta_new_puesto){
                        this.alerta_new_puesto = false;
                    }
                    if (this.alerta_edit_puesto){
                        this.alerta_edit_puesto = false;
                    }
                }
            });
        }
    }  
}
</script>

<style>

</style>